import { enablePointerEvents } from '@utils/pointer-events-control';
import { config, gameState } from '../index';

let selectionCode = 0;

let inputNumber = 0;
let keypadEnable = false;

let textEntry = null;

let hundredsText = null;
let tensText = null;
let onesText = null;

const flasher = null;

let gamestage = 0;
let inputstage = 0;

let makecheck = false;

let diasableflash = false;
let enableflash = false;

let questionnumber = 0;
let correct = 0;
let A = null;
let B = null;

export default class GameScene extends Phaser.Scene {
  constructor() {
    super({
      key: 'GameScene',
    });
  }

  preload() {}

  create() {
    // Enable pointer events so hover states and the cursor work
    enablePointerEvents();

    // Reset module-level state for replay
    selectionCode = 0;
    inputNumber = 0;
    keypadEnable = false;
    gamestage = 0;
    inputstage = 0;
    makecheck = false;
    diasableflash = false;
    enableflash = false;
    questionnumber = 0;
    correct = 0;

    // this.load.audio("bgMusic", "assets/Audio/mysterious-cave-ambiance-1.mp3");
    // this.load.audio("doorUnlock", "assets/Audio/Automatic-door-unlock-slide-open.mp3");
    // this.load.audio("logoReveal", "assets/Audio/Beauty-intro-reveal-logo-2.mp3");
    // this.load.audio("keyTurn", "assets/Audio/Doorknob-unlock.mp3");
    // this.load.audio("correctAnswer", "assets/Audio/Feedback-correct.mp3");
    // this.load.audio("incorrectAnswer", "assets/Audio/Error-prompt-alert.mp3");
    // this.load.audio("chestOpen", "assets/Audio/Wood-chest-cover-opening.mp3");
    // this.load.audio("gemReveal", "assets/Audio/New-level-up-2-upgrade-1up-videogame-upgrade-1up-videogame.mp3");
    // this.load.audio("confetti", "assets/Audio/confetti.wav");

    const volumeVal = 0.2;

    this.correctAudio = this.sound.add('correctAnswer').setVolume(volumeVal);
    this.incorrectAudio = this.sound.add('incorrectAnswer').setVolume(volumeVal);
    this.keyAudio = this.sound.add('keyTurn').setVolume(volumeVal);

    if (gameState.level == 1) {
      this.load.video('logo', 'assets/EndSceneAssets/LOGO.mp4');
      this.load.start();
    } else if (gameState.level == 3) {
      this.load.multiatlas(
        'DoorAnim',
        'assets/EndSceneAssets/Door animation/DoorAnim.json',
        'assets/EndSceneAssets/Door animation',
      );

      //this.load.multiatlas('doorAnim',"assets/EndSceneAssets/Door animation/doorAnim.json","assets/EndSceneAssets/Door animation");
      this.load.start();
    }

    this.anims.create({
      key: 'epop',
      frames: this.anims.generateFrameNames('confettiAnim', {
        start: 0,
        end: 78,
        prefix: 'confetti',
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.anims.create({
      key: 'rotate',
      frames: this.anims.generateFrameNames('KeyNewAnim', {
        start: 0,
        end: 68,
        prefix: 'KEY',
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.bg = this.add.image(0, 0, 'bg').setOrigin(0, 0);
    this.bg2 = this.add.image(1280, 0, 'bg2').setOrigin(0, 0);

    this.scenario(0);

    this.input.keyboard.on('keydown', function (event) {
      if (inputstage == 1) {
        textEntry = onesText;
      } else if (inputstage == 2) {
        textEntry = tensText;
      } else if (inputstage == 3) {
        textEntry = hundredsText;
      }

      if (event.keyCode === 8 && textEntry.text.length > 0) {
        textEntry.text = '';

        enableflash = true;
      } else if (
        ((event.keyCode >= 96 && event.keyCode <= 105) ||
          (event.keyCode >= 48 && event.keyCode <= 57)) &&
        inputstage >= 1
      ) {
        textEntry.text = event.key;
        diasableflash = true;
        makecheck = true;
      }
    });
  }

  scenario(xmove) {
    this.createnumber();

    this.TA1 = this.add.text(543 + xmove, 320, this.A1, {
      fontFamily: 'font1',
      fontSize: '50px',
      fill: '#00000',
    });
    this.TA2 = this.add.text(615 + xmove, 320, this.A2, {
      fontFamily: 'font1',
      fontSize: '50px',
      fill: '#00000',
    });
    this.TA3 = this.add.text(683 + xmove, 320, this.A3, {
      fontFamily: 'font1',
      fontSize: '50px',
      fill: '#00000',
    });

    this.TB1 = this.add.text(543 + xmove, 400, this.B1, {
      fontFamily: 'font1',
      fontSize: '50px',
      fill: '#00000',
    });
    this.TB2 = this.add.text(615 + xmove, 400, this.B2, {
      fontFamily: 'font1',
      fontSize: '50px',
      fill: '#00000',
    });
    this.TB3 = this.add.text(683 + xmove, 400, this.B3, {
      fontFamily: 'font1',
      fontSize: '50px',
      fill: '#00000',
    });

    this.checkbutton = this.add
      .image(559 + xmove, 561, 'checkbutton')
      .setOrigin(0)
      .setAlpha(0)
      .setInteractive({ cursor: 'pointer' });
    this.confetti = this.add
      .sprite(650 + xmove, 340, 'confettiAnim')
      .setDepth(1)
      .setScale(1.5);
    this.key = this.add.sprite(638 + xmove, 357, 'KeyNewAnim').setDepth(1);

    this.checkbutton.on(
      'pointerover',
      function (pointer) {
        this.checkbutton.setTexture('checkbutton_on');
        //this.scene.pause("GameLoadScene");
      },
      this,
    );

    this.checkbutton.on(
      'pointerout',
      function (pointer) {
        this.checkbutton.setTexture('checkbutton');
        //this.scene.resume("GameLoadScene");
      },
      this,
    );

    //
    //this.key.play("rotate")

    //     this.textBox1 = this.add.sprite(96, 28, "textBox1").setOrigin(0);

    this.hundredsInput = this.add
      .sprite(539 + xmove, 469, 'input2')
      .setOrigin(0)
      .setScale(1.2, 1.2)
      .setInteractive({ cursor: 'pointer' });
    this.tensInput = this.add
      .sprite(606 + xmove, 469, 'input2')
      .setOrigin(0)
      .setScale(1.2, 1.2)
      .setInteractive({ cursor: 'pointer' });
    this.onesInput = this.add
      .sprite(673 + xmove, 469, 'input2')
      .setOrigin(0)
      .setScale(1.2, 1.2)
      .setInteractive({ cursor: 'pointer' });

    hundredsText = this.add
      .text(539 + 25 + xmove, 469 + 33, '', {
        fontFamily: 'font1',
        fontSize: '50px',
        fill: '#000000',
      })
      .setOrigin(0.5, 0.5);
    tensText = this.add
      .text(606 + 25 + xmove, 469 + 33, '', {
        fontFamily: 'font1',
        fontSize: '50px',
        fill: '#000000',
      })
      .setOrigin(0.5, 0.5);
    onesText = this.add
      .text(673 + 25 + xmove, 469 + 33, '', {
        fontFamily: 'font1',
        fontSize: '50px',
        fill: '#000000',
      })
      .setOrigin(0.5, 0.5);

    this.xadjust = 24;
    this.yadjust = 19;

    this.hundredsCursor = this.add
      .sprite(539 + this.xadjust + xmove, 469 + this.yadjust, 'cursor')
      .setOrigin(0)
      .setVisible(false);
    this.tensCursor = this.add
      .sprite(606 + this.xadjust + xmove, 469 + this.yadjust, 'cursor')
      .setOrigin(0)
      .setVisible(false);
    this.onesCursor = this.add
      .sprite(673 + this.xadjust + xmove, 469 + this.yadjust, 'cursor')
      .setOrigin(0)
      .setVisible(false);

    this.flash1 = this.plugins.get('rexflashplugin').add(this.hundredsCursor, {
      duration: 700,
      repeat: 1000,
    });

    this.flash2 = this.plugins.get('rexflashplugin').add(this.tensCursor, {
      duration: 700,
      repeat: 1000,
    });

    this.flash3 = this.plugins.get('rexflashplugin').add(this.onesCursor, {
      duration: 700,
      repeat: 1000,
    });

    this.hundredsInput.on(
      'pointerdown',
      () => {
        inputstage = 3;

        this.flash2.stop();
        this.tensCursor.setVisible(false);
        this.flash3.stop();
        this.onesCursor.setVisible(false);

        if (hundredsText.text == '') {
          this.flash1.flash();
        }
        this.hundredsInput.setTexture('input3');
        this.tensInput.setTexture('input2');
        this.onesInput.setTexture('input2');
      },
      [],
      this,
    );

    this.tensInput.on(
      'pointerdown',
      () => {
        inputstage = 2;

        this.flash1.stop();
        this.hundredsCursor.setVisible(false);

        this.flash3.stop();
        this.onesCursor.setVisible(false);

        if (tensText.text == '') {
          this.flash2.flash();
        }

        this.hundredsInput.setTexture('input2');
        this.tensInput.setTexture('input3');
        this.onesInput.setTexture('input2');
      },
      [],
      this,
    );

    this.onesInput.on(
      'pointerdown',
      () => {
        inputstage = 1;

        this.flash1.stop();
        this.hundredsCursor.setVisible(false);

        this.flash2.stop();
        this.tensCursor.setVisible(false);

        if (onesText.text == '') {
          this.flash3.flash();
        }

        this.hundredsInput.setTexture('input2');

        this.tensInput.setTexture('input2');

        this.onesInput.setTexture('input3');
      },
      [],
      this,
    );

    this.checkbutton.on(
      'pointerdown',
      () => {
        diasableflash = true;

        this.checkbutton.setAlpha(0).setScale(0, 0);

        if (hundredsText.text + tensText.text + onesText.text == this.answer) {
          inputstage = 0;

          correct++;

          this.confetti.play('epop');

          this.correctAudio.play();

          hundredsText.setColor('#149A53');
          tensText.setColor('#149A53');
          onesText.setColor('#149A53');

          this.hundredsInput.setTexture('input5').disableInteractive();

          this.tensInput.setTexture('input5').disableInteractive();
          this.onesInput.setTexture('input5').disableInteractive();
          //console.log("yes");

          this.time.delayedCall(
            500,
            () => {
              this.key.play('rotate');
              this.keyAudio.play();
            },
            this,
          );

          this.time.delayedCall(
            3000,
            () => {
              if (correct == 2) {
                this.scene.start('EndScene');
              } else {
                gamestage = -1;
                questionnumber++;
              }
            },
            this,
          );
        } else {
          gamestage = 4;

          inputstage = 0;

          this.incorrectAudio.play();

          hundredsText.setColor('#C22300');
          tensText.setColor('#C22300');
          onesText.setColor('#C22300');

          this.hundredsInput.setTexture('input4').disableInteractive();

          this.tensInput.setTexture('input4').disableInteractive();
          this.onesInput.setTexture('input4').disableInteractive();

          this.tweens.add({
            targets: [hundredsText, tensText, onesText],
            angle: {
              getEnd: function () {
                return -3.5;
              },
              getStart: function () {
                return 3.5;
              },
            },

            scale: {
              getEnd: function () {
                return 1.15;
              },
              getStart: function () {
                return 1;
              },
            },

            ease: 'Sine.easeInOut',
            duration: 400,
            repeat: 0,
            yoyo: true,
          });

          this.tweens.add({
            targets: [hundredsText, tensText, onesText],
            angle: {
              getEnd: function () {
                return 180;
              },

              getStart: function () {
                return 3.5;
              },
            },
            scale: 0,
            ease: 'Sine.easeOut',
            delay: 800,
            duration: 600,
            repeat: 0,
            yoyo: false,
          });
          this.time.delayedCall(
            2200,
            () => {
              gamestage = 3;
              //questionnumber++;

              hundredsText.setText('').setScale(1).setAngle(0);
              tensText.setText('').setScale(1).setAngle(0);
              onesText.setText('').setScale(1).setAngle(0);
              this.checkbutton.setScale(1, 1);
            },
            this,
          );
        }
      },
      [],
      this,
    );
  }

  createnumber() {
    if (gameState.level == 1) {
      A = [735, 832, 955, 673, 981, 812];
      B = [497, 398, 296, 197, 594, 198];
    } else if (gameState.level == 2) {
      A = [970, 822, 612, 873, 742, 762];
      B = [385, 288, 185, 389, 485, 286];
    } else if (gameState.level == 3) {
      A = [840, 564, 933, 701, 674, 851];
      B = [502, 307, 605, 202, 408, 504];
    }

    this.num = A[questionnumber];

    this.A3 = this.num % 10;

    this.A2 = ((this.num - this.A3) % 100) / 10;

    this.A1 = (this.num - 10 * this.A2 - this.A3) / 100;

    this.num2 = B[questionnumber];

    this.B3 = this.num2 % 10;

    this.B2 = ((this.num2 - this.B3) % 100) / 10;

    this.B1 = (this.num2 - 10 * this.B2 - this.B3) / 100;

    this.answer = this.num - this.num2;
  }

  update() {
    if (gamestage == 3) {
      gamestage = 0;

      //this.createnumber()

      //this.TA1.setText(this.A1)
      //this.TA2.setText(this.A2)
      //this.TA3.setText(this.A3)

      //this.TB1.setText(this.B1)
      //this.TB2.setText(this.B2)
      //this.TB3.setText(this.B3)

      this.hundredsInput.setTexture('input2').setInteractive({ cursor: 'pointer' });
      this.tensInput.setTexture('input2').setInteractive({ cursor: 'pointer' });
      this.onesInput.setTexture('input2').setInteractive({ cursor: 'pointer' });

      hundredsText.setColor('#000000');
      tensText.setColor('#000000');
      onesText.setColor('#000000');
    } else if (gamestage == -1) {
      gamestage = 0;
      this.scenario(1280);
      inputstage = 0;

      const cam = this.cameras.main;

      cam.pan(1280 + 640, 360, 2000);

      if (gameState.level == 1) {
        this.time.delayedCall(
          2000,
          () => {
            this.load.multiatlas(
              'chest2OpenAnim',
              'assets/EndSceneAssets/ChestTwoAnim/ChestTwoAnim.json',
              'assets/EndSceneAssets/ChestTwoAnim',
            );

            this.load.start();
          },
          this,
        );
      }

      this.createnumber();

      this.TA1.setText(this.A1);
      this.TA2.setText(this.A2);
      this.TA3.setText(this.A3);

      this.TB1.setText(this.B1);
      this.TB2.setText(this.B2);
      this.TB3.setText(this.B3);

      this.hundredsInput.setTexture('input2').setInteractive({ cursor: 'pointer' });
      this.tensInput.setTexture('input2').setInteractive({ cursor: 'pointer' });
      this.onesInput.setTexture('input2').setInteractive({ cursor: 'pointer' });
    }

    if (enableflash) {
      enableflash = false;
      if (inputstage == 1) {
        this.flash3.flash();
      } else if (inputstage == 2) {
        this.flash2.flash();
      } else if (inputstage == 3) {
        this.flash1.flash();
      }
    }

    if (diasableflash) {
      diasableflash = false;

      this.flash1.stop();
      this.hundredsCursor.setVisible(false);

      this.flash2.stop();
      this.tensCursor.setVisible(false);

      this.flash3.stop();
      this.onesCursor.setVisible(false);
    }

    if (makecheck) {
      makecheck = false;
      this.tweens.add({
        targets: this.checkbutton,
        alpha: 1,
        ease: 'Cubic', // 'Cubic', 'Elastic', 'Bounce', 'Back' ,'Sine.easeOut',
        duration: 400,
        repeat: 0, // -1: infinity
        yoyo: false,
      });
    }
  }
}
